<mat-icon class="close" mat-dialog-close>close</mat-icon>
<div class="wx">
  <div class="title">
    <img
      src="../../../../assets/images/weixin.svg"
      alt=""
      width="30"
      height="30"
    />使用微信扫一扫登录
  </div>
  <app-global-loading *ngIf="!url"></app-global-loading>
  <div class="qrcode-container" *ngIf="url">
    <img class="qrcode" [src]="url" alt="" width="200" height="200" />
    <div class="refresh" *ngIf="refresh">
      <img
        class="refresh"
        src="../../../assets/images/refresh.webp"
        (click)="refreshQrcode()"
        alt=""
      />
    </div>
  </div>
</div>
